import arrayToIdIndex from "@/client/helpers/arrayToIdIndex";

const notifiesStatuses = [
  {
    id:    1,
    title: 'Активное',
  },
  {
    id:    2,
    title: 'Завершенное',
  },
  {
    id:    4,
    title: 'Отмененное',
  },
];

export default {
  dict:          arrayToIdIndex(notifiesStatuses),
  keyDict:       arrayToIdIndex(notifiesStatuses, 'key'),
  enum:          { ACTIVE: 1, COMPLETE: 2, CANCEL: 4 },
  selectOptions: notifiesStatuses.map(s => ({
    value: s.id,
    label: s.title,
  })),
};
